import subcategoryDetailsSymbols from "../symbols/subcategoryDetails";
import subcategoryProductsSymbols from "../symbols/subcategoryProducts";

import {
  HttpRequestGet,
  HttpRequestPost,
} from "../../service";

export const SUBCATEGORY_DEFAULT_ITEM_SIZE = 10;

const subcategoryDetailsSymbolsAction = () => ({
  type: subcategoryDetailsSymbols.GET_SUBCATEGORY_DETAILS,
});
const subcategoryDetailsSymbolsSuccessAction = (data: any) => ({
  type: subcategoryDetailsSymbols.GET_SUBCATEGORY_DETAILS_SUCCESS,
  payload: data,
});
const subcategoryDetailsSymbolsFailureAction = (data: any) => ({
  type: subcategoryDetailsSymbols.GET_SUBCATEGORY_DETAILS_FAILURE,
  payload: data,
});
const clearSubcategoryDetailsSymbolsAction = () => ({
  type: subcategoryDetailsSymbols.CLEAR_GET_SUBCATEGORY_DETAILS,
});

const subcategoryProductsSymbolsAction = () => ({
  type: subcategoryProductsSymbols.GET_SUBCATEGORY_PRODUCTS,
});
const subcategoryProductsSymbolsPageAction = (page: any) => ({
  type: subcategoryProductsSymbols.SET_SUBCATEGORY_PAGE,
  payload: page,
});
const subcategoryProductsSymbolsSuccessAction = (data: any) => ({
  type: subcategoryProductsSymbols.GET_SUBCATEGORY_PRODUCTS_SUCCESS,
  payload: data,
});
const subcategoryProductsSymbolsFailureAction = (data: any) => ({
  type: subcategoryProductsSymbols.GET_SUBCATEGORY_PRODUCTS_FAILURE,
  payload: data,
});
const clearSubcategoryProductsSymbolsAction = () => ({
  type: subcategoryProductsSymbols.CLEAR_GET_SUBCATEGORY_PRODUCTS,
});

export function setSubcategoryPageSymbols(page: number) {
  return (dispatch: any) => {
    dispatch(subcategoryProductsSymbolsPageAction(page));
  };
}

export function getSubcategoryDetailsSymbols(id: string) {
  return (dispatch: any) => {
    dispatch(subcategoryDetailsSymbolsAction());
    HttpRequestGet(
      "/upc/subcategory/" + id,
      dispatch,
      subcategoryDetailsSymbolsSuccessAction,
      subcategoryDetailsSymbolsFailureAction,
      true
    );
  };
}

export function getSubcategoryProductsSymbols(id: string, page: number, size: number) {
  return (dispatch: any) => {
    dispatch(subcategoryProductsSymbolsAction());
    const body = {
      SubCategoryId: id,
      Page: page,
      Size: size
    };
    HttpRequestPost(
      "/upc/subcategory/variants",
      dispatch,
      subcategoryProductsSymbolsSuccessAction,
      subcategoryProductsSymbolsFailureAction,
      true,
      body
    );
  };
}

export function clearSubcategoryProductsSymbols() {
  return (dispatch: any) => {
    dispatch(clearSubcategoryProductsSymbolsAction());
  };
}

export function clearSubcategorysSymbols() {
  console.log("Cleared");
  return (dispatch: any) => {
    dispatch(clearSubcategoryDetailsSymbolsAction());
  };
}